import clsx from 'clsx';

import { flexWrapClasses } from '../classes/flexWrapClasses';
import type { Adaptive } from '../types/Adaptive';
import type { FlexWrap } from '../types/FlexWrap';

export function composeFlexWrapClasses(color: Adaptive<FlexWrap>): string {
    if (typeof color === 'object') {
        return clsx(
            color.base && flexWrapClasses[color.base],
            color.sm && `sm:${flexWrapClasses[color.sm]}`,
            color.md && `md:${flexWrapClasses[color.md]}`,
            color.lg && `lg:${flexWrapClasses[color.lg]}`,
            color.xl && `xl:${flexWrapClasses[color.xl]}`,
            color['2xl'] && `2xl:${flexWrapClasses[color['2xl']]}`
        );
    }

    return flexWrapClasses[color];
}
